import './InsertNewData.scss'
import React from 'react'
import {useNavigate} from 'react-router-dom'
import WSButton from '../../_metronic/helpers/components/WSButton/WSButton'
import { AuthenticateUser } from '../Utils/_helpers/RoleAndPermission'
import useResponsive from '../hooks/useResponsive'

const InsertNewData = ({message, buttonName, isButtonShowing = true, roleCheck = 'send-quick-sms'}: any) => {
  const navigate = useNavigate()
  const {isMobile} = useResponsive()

  return (
    <>
      <div
        className={`card mt-5 w-355px ${isButtonShowing ? 'h-300px' : 'h-150px'} px-10 py-10 insert-new-data-card`}
      >
        {/* no data code */}
        <div className=' row align-items-center text-center justify-content-center '>
          <h1>{message?.title}</h1>

          <div className='single_data'>{message?.subtitle || ' No data yet'}</div>

          {isButtonShowing ? (
            <>
              {AuthenticateUser(roleCheck) && (
                <WSButton
                  type='button'
                  onClick={() => {
                    buttonName?.popup ? buttonName.buttonFun() : navigate(buttonName?.link)
                  }}
                  className={`btn btn-sm btn-icon btn-primary ${isMobile ? 'w-50' : 'w-25'} m-5 text-nowrap`}
                >
                  {buttonName?.name}
                </WSButton>
              )}
            </>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default InsertNewData
